import { render, staticRenderFns } from "./AppletTransferPage.vue?vue&type=template&id=96b9d7ee&scoped=true&"
import script from "./AppletTransferPage.vue?vue&type=script&lang=ts&"
export * from "./AppletTransferPage.vue?vue&type=script&lang=ts&"
import style0 from "./AppletTransferPage.vue?vue&type=style&index=0&id=96b9d7ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@rakete/cli-plugin-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b9d7ee",
  null
  
)

export default component.exports